import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class SubjectService {
static subjectCreate = async (values) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/subject/create",
        data: values,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static subjectDetailsSearch = async (rowsPerPage, page) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/subject/admin/search",
        data: {
          filter: [],
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let subjectDetail = response.data.data;
      return subjectDetail;
    } catch (err) {
      throw err;
    }
  };

  static subjectDetailsID = async (subjectID) => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/subject/admin/" + subjectID,
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let subjectDetailID = response.data.data;

      return subjectDetailID;
    } catch (err) {
      throw err;
    }
  };

  static subjectDelete = async (subjectID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/subject/admin/" + subjectID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static subjectUpdate = async (subjectID, bodydata) => {
    try {
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/subject/" + subjectID,
        data: bodydata,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

}
